<app-modal-header (closeModal)="close()" />
<app-modal-body>
  @defer (when markerList.data.length > 0) {
    <h1 class="fw-medium fs-5 mb-3">{{ 'WHERE_WOULD_YOU_LIKE_TO_GO' | translate }}</h1>
    <div class="row">
      @for (item of markerList.data; track $index) {
        <div class="col-12 col-md-4 mb-4" tabindex="0" (click)="selectMarker(item)" role="button">
          <div class="card-dashed">
            <i class="ri-map-pin-line fs-3 me-1"></i>
            <p class="fw-medium mb-0 mt-2">{{ item.identifier }}</p>
            <p class="mb-0">{{ item.map_name }}</p>
          </div>
        </div>
      }
    </div>
  } @placeholder {
    @if (isShowPlaceholder) {
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '30px',
        }"
      />
      <app-skeleton-product-list />
    }
  }
</app-modal-body>
